module.exports = __webpack_public_path__ + "static/qrcode-1870f7f725bb50d68a5134aba96a9b18.png";